import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { intersectKeys } from "keautils";

/**Filtra todas las ubicaciones que encajen con el arreglo de colonias especificado. Note que si el arreglo de colonias esta vacio la respuesta también estará vacía */
export function filtrarUbicacionesPorColonias(ubicaciones: models.Ubicaciones, colonias: models.ColoniaDTO[]): models.Ubicaciones {
    const idCiudades = colonias.map(x => x.IdCiudad);
    const idMunicipios = colonias.map(x => x.IdMunicipio);
    const idEstados = colonias.map(x => x.IdEstado);

    const ciudad = intersectKeys(ubicaciones.ciudad, idCiudades, x => x.IdRegistro);
    const municipio = intersectKeys(ubicaciones.municipio, idMunicipios, x => x.IdRegistro);
    const estado = intersectKeys(ubicaciones.estado, idEstados, x => x.IdRegistro);

    return { ciudad, municipio, estado };
}

/**Determina si un filtro de colonia es válido, si no tiene ningun valor para filtrar se considera que NO es valido */
export function esFiltroColoniaValido(filtro: models.FiltroColonia) {
    return filtro.CodigoPostal != null || filtro.IdCiudad != null || filtro.IdMunicipio != null || filtro.IdEstado != null;
}


/**Obtiene la descripción de una dirección */
export function obtenerDescripcionDireccion(value: models.Direccion, colonia: models.ColoniaDTO) {
    return `${value.Calle || ""} #${value.NoExterior || ""} col. ${colonia.Nombre || ""} CP ${colonia.CodigoPostal || ""} ${(colonia.IdCiudad ? colonia.NombreCiudad : colonia.NombreMunicipio)}, ${colonia.NombreEstado}`;
}


// WEBPACK FOOTER //
// ./app/features/componentes/direccion/logic.tsx